import { z } from 'zod';

export type ExperimentViewedEventType = 'ExperimentViewed';

// Example event payload schemas
export const ExperimentViewedPayloadSchema = z.object({
  experimentKey: z.string(),
  experimentVariation: z.string(),
});

export type ExperimentViewedEventTypePayloadMap = {
  ExperimentViewed: z.infer<typeof ExperimentViewedPayloadSchema>;
};

export const ExperimentViewedEventSchemaMap = {
  ExperimentViewed: ExperimentViewedPayloadSchema,
};
